import { Component, OnInit, input } from '@angular/core';

import { CurrencyPipe, DynamicHtmlDirective } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { ResizeService } from '../../../../service/resize.service';
import { UserDataService } from '../../../../service/userDataService';

@Component({
    selector: 'app-pix-status-process',
    imports: [TranslateModule, CurrencyPipe, DynamicHtmlDirective],
    templateUrl: './pix-status-process.component.html',
    styleUrl: './pix-status-process.component.scss',
})
export class PixStatusProcessComponent implements OnInit {
    processingAmount = input.required<number>();
    brandId = input.required<string>();
    processingTime: string;
    constructor(
        private userDataService: UserDataService,
        private resizeService: ResizeService,
    ) {}
    ngOnInit(): void {
        this.resizeService.resizeCashier();
        this.processingTime = this.userDataService?.userData?.configParams?.pixBrInfo?.processingTime;
    }
}
